import { PAGE_SIZE } from '@constants/common.constants';
import { MEMBER_HISTORICAL_NOTICES_ACTION_TYPES } from '@constants/actionTypes/memberHistoricalNoticesActionTypes';
import {
    HISTORICAL_NOTICES_DEFAULT_SORT_COLUMN,
    HISTORICAL_NOTICES_DEFAULT_SORT_ORDER,
    HISTORICAL_NOTICES_INITIAL_PAGE_NUMBER,
    type IHistoricalNoticesListState,
} from '@modules/historical-notices/constants';

export const INITIAL_STATE: IHistoricalNoticesListState = {
    hasLoaded: false,
    notices: [],
    totalCount: 0,
    pageNumber: HISTORICAL_NOTICES_INITIAL_PAGE_NUMBER,
    pageSize: PAGE_SIZE,
    totalPages: 0,
    sortColumn: HISTORICAL_NOTICES_DEFAULT_SORT_COLUMN,
    sortOrder: HISTORICAL_NOTICES_DEFAULT_SORT_ORDER,
    hasLoadError: false,
};

function memberHistoricalNoticesReducer(
    state = INITIAL_STATE,
    action: { type?: string; payload?: IHistoricalNoticesListState } = {},
) {
    switch (action.type) {
        case MEMBER_HISTORICAL_NOTICES_ACTION_TYPES.SET_MEMBER_HISTORICAL_NOTICES: {
            if (!action.payload) {
                return state;
            }

            return { ...state, ...action.payload };
        }
        case MEMBER_HISTORICAL_NOTICES_ACTION_TYPES.RESET_MEMBER_HISTORICAL_NOTICES:
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default memberHistoricalNoticesReducer;
